import React from 'react';
import { tone as toneOf } from './tones';

/** Soft status pill with an optional leading dot or icon. tone: brand|success|warning|danger|info|violet|neutral. */
export default function StatusTag({ tone = 'neutral', dot = false, icon, children, className = '' }) {
    const t = toneOf(tone);
    return (
        <span className={`inline-flex items-center gap-1.5 h-6 px-2 rounded-md text-xs font-medium whitespace-nowrap ${t.chip} ${className}`}>
            {dot && <span className={`h-1.5 w-1.5 rounded-full ${t.solid}`} />}
            {icon && <span className="text-[13px] flex">{icon}</span>}
            {children}
        </span>
    );
}
